const fadeSlider = document.querySelectorAll('.fade-slider-wrap');

// Initialize slider with first item active and set parent height to its highest children height
const resizeSlideItems = () => {
    fadeSlider.forEach(slider => {
        const sliderChildren = [...slider.children]
    
        let maxHeight = sliderChildren[0].getBoundingClientRect().height
    
        // Default to first slide active
        if(!slider.querySelector('is-active')) sliderChildren[0].classList.add('is-active');
    
        sliderChildren.forEach(child => {
            const height = child.getBoundingClientRect().height
            maxHeight = Math.max(height, maxHeight);
        });
    
        slider.style.height = `${maxHeight}px`;
    });
}
window.addEventListener('resize', () => resizeSlideItems)
resizeSlideItems();

// Update slider active slide every {X}ms
const changeActiveSlide = (slide) => {
    const isActive = slide.querySelector('.is-active');
    isActive.classList.remove('is-active');

    const itemArr = [...slide.children]
    let index = itemArr.indexOf(isActive)

    if(index + 1 >= itemArr.length) index = 0
    else index++;

    itemArr[index].classList.add('is-active');
}

fadeSlider.forEach(slide => {
    let interval = parseInt(slide.dataset.timer) * 1000

    if(!interval) interval = 5000
    const fadeInterval = setInterval(() => changeActiveSlide(slide), interval);
});